/**
 * @prettier
 * @flow
 */
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import * as React from 'react';
import { translate } from 'src/utils/translate/translate';

export function RefreshToolbarButton({ tooltip, onClick, disabled }: Props): React.Node {
    return (
        <Tooltip title={tooltip || translate('Refresh')}>
            <IconButton onClick={onClick} disabled={disabled}>
                <RefreshIcon />
            </IconButton>
        </Tooltip>
    );
}

type Props = {
    tooltip?: string,
    disabled?: boolean,
    onClick: Function,
};
